import styles from "./AboutUs.module.css";
import Image from "next/image";
import { useAppContext } from "@/context/Context";

export default function AboutUs() {

  const { isLightTheme } = useAppContext()
  
  const sectionClass = !isLightTheme
    ? `${styles.aboutSection} ${styles.darkThemeAboutSection}`
    : styles.aboutSection;

  return (
    <section className={`container ${sectionClass}`}>
      <div className="row align-items-center g-5" style={{padding : '2%'}}>
        <div className="col-lg-6">
          <span className={styles.tag}>🌟 ABOUT ELMS+</span>
          <h2 className={styles.heading}>
            Empowering Learning with{" "}
            <span className={styles.highlight}>ELMS+</span> Platform
          </h2>
          <p className={styles.description}>
            ELMS+ is your all-in-one digital learning and internship management
            platform. Whether you&apos;re a student, instructor, or HR, we bring
            together education, collaboration, and career growth — all in one
            place.
          </p>

          <div className={styles.features}>
            <div className={styles.featureItem}>
              <div className={styles.iconCircle}>
                <i className="feather-clock"></i>
              </div>
              <div>
                <h5 className={styles.featureTitle}>Flexible Learning</h5>
                <p className={styles.featureText}>
                  Access your courses anytime, anywhere with adaptive schedules
                  and 24/7 content availability.
                </p>
              </div>
            </div>

            <div className={styles.featureItem}>
              <div className={`${styles.iconCircle} ${styles.blue}`}>
                <i className="feather-globe"></i>
              </div>
              <div>
                <h5 className={styles.featureTitle}>Global Access</h5>
                <p className={styles.featureText}>
                  Learn, teach, and grow from any corner of the world using
                  ELMS+&apos;s interactive and multilingual platform.
                </p>
              </div>
            </div>

            <div className={styles.featureItem}>
              <div className={`${styles.iconCircle} ${styles.purple}`}>
                <i className="feather-users"></i>
              </div>
              <div>
                <h5 className={styles.featureTitle}>Collaborative Community</h5>
                <p className={styles.featureText}>
                  Connect with instructors, mentors, and fellow learners to
                  build strong professional networks.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6 text-center">
          <Image
            src="/images/about/about-us.png"
            alt="About ELMS+ Illustration"
            width={500}
            height={450}
            className={`${styles.image} img-fluid`}
            priority
          />
        </div>
      </div>
    </section>
  );
}